import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-table-actions-edit-line-renderer',
  templateUrl: './table-actions-edit-line-renderer.component.html',
  styleUrls: ['./table-actions-edit-line-renderer.component.scss']
})
export class TableActionsEditLineRendererComponent implements ICellRendererAngularComp {
  params: any;
  isEditing: boolean = false;
  isThisRowEditing: boolean = false;
  isAnyRowEditing: boolean = false;
  rowIndex: number;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.rowIndex = params.node.rowIndex;
    this.updateEditingState();
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.updateEditingState();
    return true;
  }

  private updateEditingState(): void {
    const componentParent = this.params.context.componentParent;
    this.isThisRowEditing = componentParent.editingRowIndex === this.rowIndex;
    this.isAnyRowEditing = componentParent.editingRowIndex !== null;
    this.isEditing = this.isThisRowEditing;
  }

  onEditClick(): void {
    if (this.isAnyRowEditing && !this.isThisRowEditing) {
      return;
    }

    if (this.params.onStartEdit) {
      this.params.onStartEdit(this.rowIndex);
      this.isEditing = true;
      this.isThisRowEditing = true;
    }
  }

  onSaveClick(): void {
    if (this.params.onSaveEdit) {
      this.params.onSaveEdit(this.rowIndex);
      this.isEditing = false;
      this.isThisRowEditing = false;
    }
  }

  onCancelClick(): void {
    if (this.params.onCancelEdit) {
      this.params.onCancelEdit(this.rowIndex);
      this.isEditing = false;
      this.isThisRowEditing = false;
    }
  }
}
